// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n@media (min-width: 960px) {\n.theme-3 .container {\n        max-width: 900px !important;\n}\n}\n@media (min-width: 1264px) {\n.theme-3 .container {\n        max-width: 900px !important;\n}\n}\n@media (min-width: 1300px) {\n.theme-3 .container {\n        max-width: 1300px !important;\n}\n}\n@media (min-width: 1904px) {\n.theme-3 .container {\n        max-width: 1300px !important;\n}\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
